import map from "lodash/map";

export const returnWithVideosSpaced = (
  slideArray,
  total_duration_ms,
  timelinePushMode
) => {
  //console.log("returnWithVideosSpaced");
  var next_slide_timing_override = null;
  return map(slideArray, (s, idx) => {
    if (next_slide_timing_override) {
      s.timing = next_slide_timing_override;
    }
    next_slide_timing_override = null;
    if (s.type == "video" && s.keep_sync) {
      if (idx + 1 < slideArray.length) {
        // Keep in sync even when globalTimelineElasticMode is false;
        //console.log(idx, s.transition_time_in, s.transition_time_out);
        var transition_sec = s.transition_time_in + s.transition_time_out;
        //console.log("transition_sec", transition_sec);
        var new_timing_ms = s.timing + (s.duration - transition_sec) * 1000;
        if (new_timing_ms < total_duration_ms) {
          // Absolutely do not go past the end ... give it 0 frames of extra room.
          // Note - 20200224. Do not add any buffer in the app here. Make adjustments
          // when it is being exported in services/export.
          var additional_frame_buffer = 0 * (1000 / 25);
          next_slide_timing_override = new_timing_ms - additional_frame_buffer;
        }
      }
    }
    if (s.type != "video" && timelinePushMode) {
      if (idx + 1 < slideArray.length) {
        var minimumDurationMs = 1000;
        // What's the image's duration?
        var durationMs = slideArray[idx + 1].timing - slideArray[idx].timing;

        if (durationMs < minimumDurationMs) {
          next_slide_timing_override = slideArray[idx].timing + 1000;
        }

        var minimum_end_bunching_ms = 1000;
        if (
          next_slide_timing_override >
          total_duration_ms -
            minimum_end_bunching_ms * (slideArray.length - idx - 1)
        ) {
          // Do not push off the timeline, instead bunch at the end, spread by minimum_end_bunching_ms.
          next_slide_timing_override = null;
        }
      }
    }
    return s;
  });
};
